export const HEADING_STRINGS = {
  POKE: "POKE",
  AVAILABLE_CONNECTIONS: "Matches Found",
  CONNECTED_CONNECTIONS: "My Connections",
};
